import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const cobieUpdateRegister = api(function updateRegister({ registerId, file, fileSize }) {
    return mutate(
        gql`
            mutation UpdateRegister($registerId: String!, $file: String!, $fileSize: Int) {
                updateRegister(registerId: $registerId, file: $file, fileSize: $fileSize)
            }
        `,
        { registerId, file, fileSize },
        { returns: "updateRegister" }
    )
})
